module.exports = __webpack_public_path__ + "static/media/bg_1.bfe1cbf3.jpg";